import React, { memo } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ModalConfirmarComponent } from './components';
import styles from './index.module.scss';

function ModalConfirmar({
    mostrar,
    titulo,
    texto,
    carregando=false,
    clicouCancelar,
    textoCarregando,
    clicouConfirmar,
    textoBotaoCancelar,
    textoBotaoConfirmar
}) {
    return (
        <ModalConfirmarComponent 
            show={mostrar} 
            onExited={() => {}}
            onHide={() => {}}
            size={'sm'}
            backdropClassName={[styles.modalBackdrop, 'teste'].join(' ')}            
        >
            <ModalConfirmarComponent.Header className='border-0'>
                <ModalConfirmarComponent.Title className='fw-bold'>
                    {titulo}
                </ModalConfirmarComponent.Title>
            </ModalConfirmarComponent.Header>
            <ModalConfirmarComponent.Body>
                <p className="text-center">{texto}</p>
            </ModalConfirmarComponent.Body>
            <ModalConfirmarComponent.Footer className='border-0 justify-content-between'>
                <Button
                    variant={'padrao'}
                    onClick={clicouCancelar}
                    disabled={carregando}
                >
                    <span>{textoBotaoCancelar || 'Cancelar'}</span>
                </Button>
                <Button
                    onClick={clicouConfirmar}
                    variant='success'
                    disabled={carregando}
                >
                    {carregando ? 
                        <>
                            <FontAwesomeIcon className="icone" pulse icon={["fas", 'spinner']} />
                            <span>{textoCarregando || `Carregando`}</span>
                        </> : 
                        <span>{textoBotaoConfirmar || 'Confirmar'}</span>
                    }
                </Button>
            </ModalConfirmarComponent.Footer>
        </ModalConfirmarComponent>
    )
}

export default memo(ModalConfirmar);